import { useState } from "react";

interface SplitTextProps {
  mainText?: string;
  subText?: string;
  href?: string;
  className?: string;
}

const SplitText = ({
  mainText = "Believe",
  subText = "in yourself",
  href = "#",
  className = "",
}: SplitTextProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      className={`inline-block relative no-underline ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="inline-block text-transparent">
        {mainText}

        {/* Top half */}
        <span
          className={`absolute top-0 left-0 text-black transition-transform duration-300 overflow-hidden
                    ${isHovered ? "-translate-y-2" : ""}`}
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 50%)",
          }}
        >
          {mainText}
        </span>

        {/* Bottom half */}
        <span
          className={`absolute top-0 left-0 text-black transition-transform duration-300 overflow-hidden
                    ${isHovered ? "translate-y-2" : ""}`}
          style={{
            clipPath: "polygon(0 50%, 100% 50%, 100% 100%, 0 100%)",
          }}
        >
          {mainText}
        </span>

        {/* Revealed text */}
        <span
          className={`absolute top-1/2 left-0 -translate-y-1/2 w-full text-black !bg-yellow-300
                    text-xs tracking-widest text-center
                    transition-transform duration-300 origin-center
                    ${isHovered ? "scale-y-100" : "scale-y-0"}`}
        >
          {subText}
        </span>
      </span>
    </a>
  );
};

export default SplitText;
